<template>
  <main-navigation
    v-bind="{
      tabs: menuItems,
      current: currentRoute()
    }"
    @goto="goto"
    @goToDashboard="goToDashboard"
  >
    <template #right>
      <main-navigation-mini-card
        v-bind="{
          user,
          adminOptions,
          isManager,
          isStylist,
          isSuperuser,
          username,
          name,
          fullName,
        }"
        @goto="goto"
        @showAdminOptions="showAdminOptions($event)"
        @goBackToAccount="goBackToAccount()"
      />
    </template>
  </main-navigation>
</template>

<script>
import { API_ROOT } from '@/config';
import integrable from '@/components/mixins/integrable';
import MainNavigation from './MainNavigation';
import MainNavigationMiniCard from './MainNavigationMiniCard';

export default {
  name: 'MainNavigationContainer',
  components: {
    MainNavigation,
    MainNavigationMiniCard,
  },
  mixins: [integrable],
  props: {
    role: {
      type: String,
      default: 'stylist',
    },
  },
  data() {
    return {
      isSwitchUi: false,
    };
  },
  computed: {
    name() {
      return `${this.user.profile.user.first_name} ${this.user.profile.user.last_name}`;
    },
    fullName() {
      let { name } = this;
      const fullName = name.length > 24 ? (name = `${name.slice(0, 23)} ...`) : name;
      return fullName;
    },
    username() {
      return this.name;
    },
    isManager() {
      const role = this.user ? this.user.profile.role : this.role;
      return role.includes('manager');
    },
    isStylist() {
      const role = this.user ? this.user.profile.role : this.role;
      return role.includes('stylist');
    },
    // Returns an User object if the account is used as 'View as'
    isSuperuser() {
      return this.$store.getters['account/isSuperuser'];
    },
    superuser() {
      return this.$store.state.account.superuser.user;
    },
    menuItems() {
      // console.warn('Recreating menu items');

      const catalogEnabled = this.useFeature('product_catalog');
      const appointments = this.useFeature('appointments');

      // const hasSales = this.$store.state.account.user
      //   ? this.isIntegrated
      //   : false;

      const stylistMode = this.isStylist && !this.adminOptions;
      const adminMode = this.isManager && this.adminOptions;

      const allTabs = [
        {
          icon: 'sidebar_activity',
          text: this.$t('Dashboard'),
          link: 'dashboard',
          show: stylistMode,
        },
        {
          icon: 'sidebar_activity',
          text: this.$t('Dashboard'),
          link: 'admin/dashboard',
          show: adminMode,
        },
        {
          icon: 'sidebar_clients',
          text: this.$t('Clients'),
          link: 'clients/my',
          show: stylistMode,
        },
        {
          icon: 'sidebar_clients',
          text: this.$t('Clients'),
          link: 'admin/clients',
          show: adminMode,
        },
        {
          icon: 'sidebar_outreach',
          text: this.$t('Outreach'),
          link: 'entries',
          show: stylistMode,
        },
        {
          icon: 'sidebar_report',
          text: this.$t('Reports'),
          link: 'admin/reports',
          show: adminMode,
        },
        {
          icon: 'sidebar_report',
          text: this.$t('Reports'),
          link: 'reports',
          show: stylistMode,
        },
        {
          icon: 'sidebar_inventory',
          text: this.$t('Inventory'),
          link: 'inventory',
          show: catalogEnabled,
        },
        {
          icon: 'sidebar_album',
          text: this.$t('navbar.assets'),
          link: 'assets',
          show: true,
        },
        {
          icon: 'sidebar_appointments',
          text: this.$t('Appointments'),
          link: 'appointments',
          show: appointments && stylistMode,
        },
      ];
      const userTabs = allTabs.filter((tab) => tab.show);
      return userTabs;
    },
    user() {
      return this.$store.state.account.user;
    },
    adminOptions() {
      return this.$store.state.account.isAdminMode;
    },
  },
  methods: {
    currentRoute() {
      // Special cases
      if (this.$route.name === 'admin.team.show') {
        return '/dashboard';
      }
      return this.$route.path;
    },
    goto(route) {
      if (this.$route.path === `/${route}`) {
        return;
      }
      this.$router.push(`/${route}`);
    },
    goBackToAccount() {
      const { token } = this.$store.state.account.superuser;
      window.location.href = `/login?token=${token}`;
    },
    goToAdminPage() {
      const url = '/admin/api/customer/';
      const key = JSON.parse(localStorage.getItem('user')).token;
      window.open(`${API_ROOT}/tokenlogin?key=${key}&url=${url}`);
    },
    goToDashboard() {
      this.$router.push('/dashboard');
    },
    showAdminOptions(show) {
      this.$store.dispatch('account/setAdminMode', show);
      this.$router.push(`/${this.menuItems[0].link}`);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
